//   Description : Callouts Component

//dependencies
import React, { useState, useEffect } from 'react';
import MailModal from "./MailModal";
import MUIDataTable from 'mui-datatables';
import { CircularProgress, Typography } from '@mui/material';
import Axios from '../../../axios/Axios';
// import { ShowMoreText } from '../../Reusable/ShowMoreText';

//Redux
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../../redux/features/appSlice';

//CSS
import "../../../css/Callouts.css";
import { Dropdown } from 'react-bootstrap';
import { MoreVert } from '@mui/icons-material';
import CommentsModalReuse from '../../Reusable/CommentsModalReuse';
import { ShowFullText } from '../../Reusable/ShowMoreText';
import axios from 'axios';
import dayjs from 'dayjs';


export const CalloutsNew = () => {

    const dispatch = useDispatch();
    const [calloutList, setCalloutList] = useState([]);
    const [isDataFetchError, setIsDataFetchError] = useState(false);
    const [rowData, setRowData] = useState([]);
    const [commentModal, setCommentModal] = useState(false);

    // for comment section 
    const [reloadComments, setReloadComments] = useState(false);
    const handleCommentsModalClose = () => {
        setReloadComments(!reloadComments);
    };

    // for pagination state 
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const handleRowsPerPageChange = (newRowsPerPage) => {
        setRowsPerPage(newRowsPerPage);
    };


    // GET Request : To fetch callout list
    useEffect(() => {
        const controller = axios.CancelToken.source();
        (async () => {
            try {
                const options = {
                    method: "get",
                    url: `/callout/viewcallout`,
                    auth: true,
                    data: null,
                    token:{cancelToken: controller.token}
                };

                const response = await Axios(
                    options.method,
                    options.url,
                    options.auth,
                    options.data,
                    options.token,
                );
                response.data.length !== 0 ? setCalloutList(response.data) : setIsDataFetchError(true);

            } catch (err) {
                if (!axios.isCancel(err)) {
                    setIsDataFetchError(true)
                    dispatch(
                        showSnackbar({
                            message: "Couldn't able to retrieve data",
                            severity: "error",
                        })
                    );
                }
            }
        })()

        return () => {
            controller.cancel();
        }
    }, [dispatch, reloadComments, rowsPerPage])



    const columns = [
        {
            name: "callout_id",
            label: "Callout id",
            options: {
                filter: true,
                sort: false,
                display: false
            }
        },
        {
            name: "callout_type",
            label: "Callout type",
            options: {
                filter: true,
                sort: false,
                setCellProps: () => ({ align: "center" }),
                customBodyRender: (value) => !!value ? value : "-"
            }
        },
        {
            name: "emails",
            label: "To",
            options: {
                filter: true,
                sort: false,
            }
        },
        {
            name: "subject",
            label: "Subject",
            options: {
                filter: true,
                sort: false,
            }
        },
        {
            name: "category",
            label: "Category",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "message",
            label: "Message",
            options: {
                filter: true,
                sort: false,
                customBodyRender: (value) => {
                    return (
                        // value && value.length > 25 ? <ShowMoreText value={value} /> : value
                        // <ShowMoreText 
                        //  value={value}
                        //  style={{color: "blue", border: "none", backgroundColor: "transparent"}}
                        //  max={35}
                        // />
                        <ShowFullText title={value}>
                            <Typography variant='p' sx={{ cursor: "pointer" }}>
                                {value && value.length > 25 ? `${value.substring(0, 50)}... ` : value}
                            </Typography>
                        </ShowFullText>
                    )
                }
            }

        }, {
            name: "created_by",
            label: "Created By",
            options: {
                filter: true,
                sort: false,
            }
        },
        {
            name: "created_at",
            label: "Created at",
            options: {
                filter: true,
                sort: true,
                sortDirection: "desc",
                customBodyRender: (value) => {
                    // const date = new Date((typeof value === "string" ? new Date(value) : value).toLocaleString("in-KL", {timeZone: "UTC"}));
                    // return `${date.getDate()} / ${date.getMonth()} / ${date.getFullYear()}, ${date.getHours()}:${date.getMinutes()}`;   
                    const formattedDate = dayjs(value).format("DD-MM-YYYY");
                    return value ? formattedDate : "";
                }
            }
        },
        {
            name: "comment_desc",
            label: "Comments",
            options: {
                filter: true,
                sort: false,
                setCellProps: () => ({ align: "center" }),
                customBodyRender: (value) => !!value ? value : "-"
            }
        },
        {
            name: "ACTIONS",
            options: {
                filter: false,
                sort: false,
                download: false,
                // empty: true,
                customBodyRender: (value, data) => {
                    // console.log(isSpocAssigned);
                    return (
                        <div>
                            <Dropdown>
                                <Dropdown.Toggle
                                    variant="primary rounded-circle"
                                    id="dropdown-basic"
                                >
                                    <MoreVert />
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={() => setCommentModal(true)}>
                                        Create / View comment
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    );
                },
            },
        },
    ];

    const options = {
        textLabels: {
            body: {
                noMatch: isDataFetchError ? "Sorry, No Data available" : <CircularProgress />,
            }
        },
        filter: true,
        filterType: "dropdown",
        responsive: "standard",
        elevation: 0,
        rowsPerPage: rowsPerPage,
        rowsPerPageOptions: [5, 10, 20],
        onChangeRowsPerPage: handleRowsPerPageChange,
        fixedHeader: true,
        fixedSelectColumn: true,
        tableBodyHeight: "auto",
        jumpToPage: true,
        onRowClick: (rowData) => {
            setRowData(rowData);
            // setCommentsToModal(rowData);
        },
        customSearch: (searchQuery, currentRow, columns) => {
            currentRow.forEach(col => {
                if (col && col.toString().indexOf(searchQuery) >= 0) {
                    return setIsDataFetchError(true);
                }
            });
        }
    };

    return (
        <>
            <div className='callout-via-email'>
                <MailModal
                    onCloseCallback={handleCommentsModalClose}
                ></MailModal>
            </div>
            <div style={{ padding: "10px" }}>
                <MUIDataTable
                    title={"Callouts List"}
                    data={calloutList}
                    columns={columns}
                    options={options}
                />
            </div>
            <CommentsModalReuse
                show={commentModal}
                onHide={() => setCommentModal(false)}
                // commentstomodal={tableData}
                tabledata={rowData}
                modalname="calloutcomments"
                postcomment={"comments/callouts/add"}
                getcomment={"comments/callouts/calloutid/"}
                onCloseCallback={handleCommentsModalClose}
            />
        </>
    )
}


